export type VoiceGatewayEvent = {
  type?: string;
  v?: VoiceGatewayEvent[];
  channel_id?: string;
  user_id?: string;
  sound_url?: string;
};

export type EntranceSoundEvent = {
  userId: string;
  soundUrl: string;
};

export function parseEntranceSoundEvent(
  event: VoiceGatewayEvent,
  channelId: string,
): EntranceSoundEvent | undefined {
  if (
    event.type !== "VoiceChannelEntranceSound" ||
    event.channel_id !== channelId ||
    !event.user_id ||
    !event.sound_url
  )
    return;

  return {
    userId: event.user_id,
    soundUrl: event.sound_url,
  };
}
